import { render, staticRenderFns } from "./integration.vue?vue&type=template&id=2bab71ff"
import script from "./integration.vue?vue&type=script&lang=js"
export * from "./integration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports